/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Submit_More_ApplicationsInputs */

const en_candidate_profile_submit_more_applications = /** @type {(inputs: Candidate_Profile_Submit_More_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit more applications`)
};

const de_candidate_profile_submit_more_applications = /** @type {(inputs: Candidate_Profile_Submit_More_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Bewerbungen einreichen`)
};

/**
* | output |
* | --- |
* | "Submit more applications" |
*
* @param {Candidate_Profile_Submit_More_ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_submit_more_applications = /** @type {((inputs?: Candidate_Profile_Submit_More_ApplicationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Submit_More_ApplicationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_submit_more_applications(inputs)
	return en_candidate_profile_submit_more_applications(inputs)
});